module.exports = __webpack_public_path__ + "media/images/flags/aw-98298192f432c6fc56cc1899a86b8d04.svg";